import {
	preventDoubleClick
} from '../global/_doubleClick';
import {
	stripRestrictedCharFromInput
} from '../global/_stripRestrictedCharFromInput';
import {
    inlineFormValidationOnBlur
} from '../global/_inlineFormValidationOnBlur';
export const callRegistryShareFormView = (params, returnHTML) => {
    const postUrl = params.isRegistryGuest == 'yes' ? "&guestURL=" + window.location.pathname : '';
    const imageArray = [];
    params.registryItemImages?.forEach((a) => {
        if (!imageArray?.includes(a)) {
            return imageArray.push(a)
        }
    })
    var myCallback = function() {
            stripRestrictedCharFromInput();
            inlineFormValidationOnBlur();
            preventDoubleClick();
        },
        url = "/webapp/wcs/stores/servlet/RegistryShareFormView",
        data = "registryNumber=" + params.registryNumber + "&senderName=" + params.senderName + "&senderEmail=" + params.senderEmail + "&registryURL=" + params.registryURL + "&registryType=" + params.registryType  + "&registryItemImages=" + encodeURIComponent(imageArray) + "&isRegistryGuest=" + params.isRegistryGuest + postUrl;
        
    $.ajax({
        url: url,
        cache: false,
        type: "POST",
        data: data,
        success: function(html) {
            returnHTML(html, myCallback);
            return false;
        },
    });
};
